export const UnrecoverableErrorSvg = () => (
  <svg
    width="154"
    height="153"
    viewBox="0 0 154 153"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M128.853 40.8736C137.33 40.8736 144.201 33.948 144.201 25.4049C144.201 16.8618 137.33 9.93628 128.853 9.93628C120.376 9.93628 113.504 16.8618 113.504 25.4049C113.504 33.948 120.376 40.8736 128.853 40.8736Z"
      fill="#FDC221"
    />
    <path
      d="M107.974 26.1757H105.049C104.357 26.1757 103.796 25.6102 103.796 24.913C103.796 24.2158 104.357 23.6503 105.049 23.6503H107.974C108.666 23.6503 109.226 24.2158 109.226 24.913C109.226 25.6102 108.666 26.1757 107.974 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M151.407 26.1757H148.482C147.79 26.1757 147.229 25.6102 147.229 24.913C147.229 24.2158 147.79 23.6503 148.482 23.6503H151.407C152.099 23.6503 152.659 24.2158 152.659 24.913C152.659 25.6102 152.099 26.1757 151.407 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M128.228 5.76291C127.536 5.76291 126.976 5.19735 126.976 4.50019V1.55276C126.976 0.855595 127.536 0.290039 128.228 0.290039C128.92 0.290039 129.481 0.855595 129.481 1.55276V4.50019C129.481 5.19735 128.92 5.76291 128.228 5.76291Z"
      fill="#FDC221"
    />
    <path
      d="M107.974 26.1757H105.049C104.357 26.1757 103.796 25.6102 103.796 24.913C103.796 24.2158 104.357 23.6503 105.049 23.6503H107.974C108.666 23.6503 109.226 24.2158 109.226 24.913C109.226 25.6102 108.666 26.1757 107.974 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M151.407 26.1757H148.482C147.79 26.1757 147.229 25.6102 147.229 24.913C147.229 24.2158 147.79 23.6503 148.482 23.6503H151.407C152.099 23.6503 152.659 24.2158 152.659 24.913C152.659 25.6102 152.099 26.1757 151.407 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M142.55 11.7418C142.23 11.7418 141.909 11.6184 141.664 11.3718C141.176 10.8789 141.176 10.0793 141.664 9.58642L143.732 7.50221C144.222 7.00903 145.015 7.00903 145.505 7.50221C145.993 7.99511 145.993 8.79471 145.505 9.28759L143.437 11.3718C143.192 11.6184 142.871 11.7418 142.55 11.7418Z"
      fill="#FDC221"
    />
    <path
      d="M111.838 42.6936C111.517 42.6936 111.197 42.5702 110.952 42.3236C110.463 41.8304 110.463 41.0311 110.952 40.5379L113.02 38.454C113.51 37.9614 114.302 37.9611 114.792 38.4543C115.282 38.9475 115.281 39.7468 114.792 40.24L112.724 42.3239C112.479 42.5702 112.159 42.6936 111.838 42.6936Z"
      fill="#FDC221"
    />
    <path
      d="M113.907 11.7418C113.586 11.7418 113.266 11.6184 113.021 11.3718L110.953 9.28759C110.464 8.7947 110.464 7.9951 110.953 7.50221C111.442 7.00903 112.235 7.00903 112.725 7.50221L114.793 9.58642C115.281 10.0793 115.281 10.8789 114.793 11.3718C114.548 11.6184 114.227 11.7418 113.907 11.7418Z"
      fill="#FDC221"
    />
    <path
      d="M144.618 42.6936C144.297 42.6936 143.977 42.5702 143.732 42.3239L141.664 40.24C141.175 39.7468 141.175 38.9475 141.664 38.4543C142.154 37.9611 142.946 37.9614 143.436 38.454L145.504 40.5379C145.993 41.0311 145.994 41.8304 145.504 42.3236C145.259 42.5702 144.939 42.6936 144.618 42.6936Z"
      fill="#FDC221"
    />
    <path
      d="M128.228 5.76291C127.536 5.76291 126.976 5.19735 126.976 4.50019V1.55276C126.976 0.855595 127.536 0.290039 128.228 0.290039C128.92 0.290039 129.481 0.855595 129.481 1.55276V4.50019C129.481 5.19735 128.92 5.76291 128.228 5.76291Z"
      fill="#FDC221"
    />
    <path
      d="M128.228 49.0753C127.536 49.0753 126.976 48.5097 126.976 47.8126V44.8651C126.976 44.168 127.536 43.6024 128.228 43.6024C128.92 43.6024 129.481 44.168 129.481 44.8651V47.8126C129.481 48.5097 128.92 49.0753 128.228 49.0753Z"
      fill="#FDC221"
    />
    <path
      d="M107.974 26.1757H105.049C104.357 26.1757 103.796 25.6102 103.796 24.913C103.796 24.2158 104.357 23.6503 105.049 23.6503H107.974C108.666 23.6503 109.226 24.2158 109.226 24.913C109.226 25.6102 108.666 26.1757 107.974 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M151.407 26.1757H148.482C147.79 26.1757 147.229 25.6102 147.229 24.913C147.229 24.2158 147.79 23.6503 148.482 23.6503H151.407C152.099 23.6503 152.659 24.2158 152.659 24.913C152.659 25.6102 152.099 26.1757 151.407 26.1757Z"
      fill="#FDC221"
    />
    <path
      d="M133.054 100.643C131.275 100.689 129.905 102.26 129.905 104.053V109.931C129.905 111.307 128.798 112.422 127.433 112.422H126.667V94.4768C126.667 92.0246 124.694 90.0364 122.261 90.0364C119.827 90.0364 117.854 92.0246 117.854 94.4768V132.881H126.667V118.942H128.351C132.782 118.942 136.375 115.322 136.375 110.856V103.902C136.375 102.073 134.88 100.595 133.054 100.643Z"
      fill="#EE399E"
    />
    <path
      d="M57.0132 152.688L85.5207 129.352C96.8723 120.059 113.133 120.059 124.485 129.352L152.992 152.688H57.0132Z"
      fill="#DFA414"
    />
    <path
      d="M1.00732 152.688L38.271 122.184C53.1093 110.037 74.3649 110.037 89.2032 122.184L126.467 152.688H1.00732Z"
      fill="#FDC221"
    />
    <path
      d="M62.2744 60.7178C58.5892 60.7857 55.7056 63.9722 55.7056 67.6868V81.2253C55.7056 83.6323 53.7694 85.5836 51.3811 85.5836H47.9097V53.307C47.9097 48.3388 43.9137 44.3118 38.9842 44.3118C34.0548 44.3118 30.0588 48.3388 30.0588 53.307V102.494H26.484C24.3128 102.494 22.5527 100.72 22.5527 98.5321V85.8087C22.5527 82.041 19.4877 78.9942 15.7333 79.0634C12.0482 79.1314 9.16455 82.3179 9.16455 86.0325V100.245C9.16455 108.939 16.1576 115.987 24.7841 115.987H29.1164C29.4371 115.987 29.75 115.956 30.0588 115.912V153H47.9097V99.0764H53.4742C62.1007 99.0764 69.0938 92.0287 69.0938 83.3348V67.463C69.0938 63.6953 66.0288 60.6486 62.2744 60.7178Z"
      fill="#EE399E"
    />
  </svg>
);
